module.exports = __webpack_public_path__ + "img/stageSection04.8e4a5485.png";